import {titleColor} from "../../constants";

const styles = theme => ({
    root : {
        display: "flex",
        flexDirection: "column",
        width: "45%",
        alignItems: "center",
        marginBottom: "24px",
        marginLeft: "20px",
        marginRight: "20px",
        [theme.breakpoints.down("sm")]: {
            width: "95%",
        },
    },

    title: {
        color: titleColor,
    },

    subText: {
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
});

export default styles